import { createAction } from 'redux-actions';
import * as types from './actionTypes';
import { fetchFloors } from '../../../Core/Api';
import { fetchHandlerActions } from '../../../Core/Utils/fetch';

export const addFloors = createAction(
  types.ADD_FLOORS,
  fetchHandlerActions(fetchFloors)
);
